import App from "../../services/App/App.js";
import AppCatalog from "../../services/App/AppCatalog.js";
import RinvItemCatalog from "./RinvItemCatalog.js";
import ModelBody from "./RinvModel_Body.js";

// +item-level discount: prefill dari invoice item (editable)
function setItemDisc_ByInvoiceItem(item, invoiceItem) {
  // diskon PER PCS diprefill dari invoice (baris gabungan, editable)
  let soUnitDisc = 0;

  if (invoiceItem.DiscPercent !== null && invoiceItem.DiscPercent !== undefined) {
    soUnitDisc = invoiceItem.RequestedQuantity > 0
      ? Math.floor(((invoiceItem.Price || 0) - (invoiceItem.TotalAfterDisc || 0)) /
          invoiceItem.RequestedQuantity)
      : 0;
  }
  else if (invoiceItem.DiscValue !== null && invoiceItem.DiscValue !== undefined) {
    soUnitDisc = App.In.getInteger(invoiceItem.DiscValue);  // Rp per pcs
  }

  item.SoUnitDisc = soUnitDisc;

  if (invoiceItem.DiscPercent !== null && invoiceItem.DiscPercent !== undefined) {
    item.DiscType = ModelBody.DiscType.Percent.ID;
    item.DiscPercent = App.In.getDecimal(invoiceItem.DiscPercent);
    item.DiscValue = "";
  }
  else if (invoiceItem.DiscValue !== null && invoiceItem.DiscValue !== undefined) {
    item.DiscType = ModelBody.DiscType.Value.ID;
    item.DiscPercent = "";
    item.DiscValue = App.In.getInteger(invoiceItem.DiscValue);
  }
  else {
    item.DiscType = ModelBody.DiscType.None.ID;
    item.DiscPercent = "";
    item.DiscValue = "";
  }
}

export default {
  setDetailsByInvoice(userData, invoiceDetails, discTypeEnum) {
    // user input
    userData.WarehouseID = invoiceDetails.WarehouseID;
    userData.SalesOrderID = invoiceDetails.ID;
    // defined by system
    userData.SONumber = invoiceDetails.SONumber;
    userData.SalesOrderDate = App.In.getDate(invoiceDetails.InvoiceDate);
    userData.ClientID = invoiceDetails.ClientID;
    userData.ClientAlias = invoiceDetails.ClientAlias;
    userData.ClientName = invoiceDetails.Client;
    userData.ClientAddress = invoiceDetails.ClientAddress;

    if (invoiceDetails.DiscValue !== null) {
      userData.DiscType = discTypeEnum.Value.ID;
      userData.DiscValue = App.In.getInteger(invoiceDetails.DiscValue);
    }
    else if (invoiceDetails.DiscPercent !== null) {
      userData.DiscType = discTypeEnum.Percent.ID;
      userData.DiscPercent = App.In.getDecimal(invoiceDetails.DiscPercent);
    }
  },
  setItemByInvoiceItem(item, invoiceItem) {
    // user input
    item.DispatchID = invoiceItem.DispatchID;
    item.PackagingName = invoiceItem.PackagingName;
    item.Quantity = App.In.getInteger(invoiceItem.QtyAvailable);
    item.SellPrice = App.In.getInteger(invoiceItem.SellPrice);
    // +item-level discount (prefill dari invoice — editable)
    setItemDisc_ByInvoiceItem(item, invoiceItem);
    // defined by system
    item.DispatchName = invoiceItem.Name;
    item.PackagingValue = invoiceItem.PackagingValue;
    item.SKU = invoiceItem.SKU;
    item.DispatchIsActive = App.In.getBoolean(invoiceItem.DispatchIsActive);
    item.InvoiceItemQty = invoiceItem.QtyAvailable;
    item.Index = invoiceItem.Index;
  },

  getItemInfo(item) {
    let infoList = [];

    // deleted item
    if (!item.DispatchIsActive) {
      infoList.push(AppCatalog.Info.DeletedItem);
    }

    if (item.DispatchIsActive) {
      // SKU
      infoList.push(RinvItemCatalog.SKU.Label + ": " +
        App.Value.getValue("SKU", item, RinvItemCatalog)
      );
    }

    return infoList;
  }
}